import styled, { css } from "styled-components";
import { Button } from "../../../button/button";

export const Controls = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 1rem;
`;

export const ControlButton = styled(Button)`
  background-color: ${({ bgcolor, theme }) => bgcolor || theme.palette.gray[500]};
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const ControlButtonSkip = styled(ControlButton)`
  transform: rotate(25deg);
`;

export const ControlButtonBack = styled(ControlButton)`
  transform: rotate(-25deg);
  svg {
    transform: scaleX(-1);
  }
`;

export const ControlButtonPlay = styled(ControlButton)`
  background: ${({ theme }) => theme.colors.card};
`;

export const WaveContainer = styled.div`
  display: none;
`;

export const ControllPlayContainer = styled.div`
  ${({ isPlaying }) =>
    isPlaying &&
    css`
      ${WaveContainer} {
        display: flex;
      }
      ${ControlButtonPlay} {
        display: none;
      }
      &:hover {
        ${WaveContainer} {
          display: none;
        }
        ${ControlButtonPlay} {
          display: flex;
        }
      }
    `}
`;

export const ControlButtonTimeSkip = styled.span`
  position: absolute;
  font-size: 11px;
  background-color: ${({ theme }) => theme.colors.background};
  bottom: 5px;
  display: block;
  z-index: 1;
  padding-right: 5px;
  left: 2px;
`;
export const ControllButtonContainer = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;

  ${({ position }) =>
    position === "right" &&
    css`
      ${ControlButtonTimeSkip} {
        right: 0;
        left: auto;
        padding-left: 5px;
      }
    `}
`;
